import Image from 'next/image';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Link from 'next/link';

import Button from 'src/components/Button';

import theme from 'src/styles/components/RestaurantNotFound.module.scss';

import { ERROR_DESCRIPTION } from './constatns';

const ErrorPage = ({ errorCode }) => {
    const intl = useIntl();

    const errorTranslation = ERROR_DESCRIPTION[errorCode];

    return (
        <div className={theme.container}>
            <div className={theme.icon}>
                <Image
                  src="/images/restaurant-not-found-icon.svg"
                  width={120}
                  height={120}
                  unoptimized="true"
                />
            </div>
            <h1>
                {errorCode}
            </h1>
            <h3>
                {intl.formatMessage({ id: errorTranslation?.title || 'App.restaurantNotFoundTile' })}
            </h3>
            <h5>
                {intl.formatMessage({ id: errorTranslation?.subtitle || 'App.restaurantNotFoundSubtitle' })}
            </h5>
            <div>
                <Link href="/">
                    <Button
                      accent
                      raised
                    >{intl.formatMessage({ id: 'App.mainPage' })}</Button>
                </Link>
            </div>
        </div>
    );
};

ErrorPage.propTypes = {
    errorCode: PropTypes.number
};

export default ErrorPage;
